import React, { useState, useEffect, useCallback } from "react";

export const SubElements = () => {
  const [showButton, setShowButton] = useState(false);

  const handleScroll = () => {
    setShowButton(window.scrollY > 200);
  };

  const closeMobileSidebar = useCallback(() => {
    document.body.classList.remove("vertical-sidebar-enable");
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <div
        className="vertical-overlay"
        onClick={closeMobileSidebar}
        aria-hidden="true"
      />
      <button
        type="button"
        style={{ display: showButton ? "block" : "none" }}
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className="btn btn-danger btn-icon"
        id="back-to-top"
        aria-label="Back to top"
      >
        <i className="ri-arrow-up-line" aria-hidden="true" />
      </button>
    </>
  );
};
